import { MouseEvent, ReactElement, cloneElement } from 'react';
import { SubmenuTriggerContext, useMenuContext } from './MenuContext';

/**
 * Submenu.Trigger
 *
 * Wraps a `Menu.Item` (or any single element) to make it open the nearest
 * `Submenu` when clicked. Analogous to `Menu.Trigger` but for nested submenus.
 * Must be rendered inside a `<Submenu>` context.
 */

interface SubmenuTriggerProps {
  children: ReactElement; // only accepts a single child
}

export function SubmenuTrigger({ children }: SubmenuTriggerProps) {
  const { anchorName, toggle } = useMenuContext();

  return (
    <SubmenuTriggerContext.Provider value={true}>
      {cloneElement(children, {
        style: { ...children.props.style, anchorName },
        onClick: async (event: MouseEvent) => {
          await children.props.onClick?.(event);
          if (event.defaultPrevented) {
            return;
          }
          toggle();
        },
      })}
    </SubmenuTriggerContext.Provider>
  );
}
